import React, { useEffect, useState } from "react";
import { Panel } from "@/pages/admin/shared";
import { Activity, ShieldCheck, LogIn, LogOut as LogOutIcon, RefreshCw } from "lucide-react";
import api from "@/pages/admin/api";

const ACTION_ICON = {
  login_success: LogIn, login_failed: ShieldCheck, logout: LogOutIcon,
};

export default function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try { const r = await api.get("/activity-logs?limit=200"); setLogs(r.data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <Panel title={`Activity Logs (${logs.length})`} subtitle="Latest admin actions and login history" actions={<button onClick={load} className="text-xs text-blue-600 hover:underline flex items-center gap-1"><RefreshCw size={12} /> {loading ? "Refreshing..." : "Refresh"}</button>}>
      {logs.length === 0 && <div className="text-sm text-muted-foreground py-8 text-center">No activity yet.</div>}
      <div className="space-y-2">
        {logs.map((l) => {
          const Icon = ACTION_ICON[l.action] || Activity;
          const isFail = l.action.includes("failed");
          return (
            <div key={l.id} className="flex items-start gap-3 rounded-xl border border-border p-3">
              <span className={`w-9 h-9 rounded-full grid place-items-center shrink-0 ${isFail ? "bg-red-50 text-red-600" : "bg-blue-50 dark:bg-blue-950/40 text-blue-600"}`}>
                <Icon size={14} />
              </span>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium capitalize">{l.action.replace(/_/g, " ")}</div>
                <div className="text-xs text-muted-foreground truncate">{l.admin_email} · {l.ip || "—"}</div>
                {l.extra && Object.keys(l.extra).length > 0 && (
                  <div className="text-[10px] text-muted-foreground mt-1 font-mono truncate">{JSON.stringify(l.extra)}</div>
                )}
              </div>
              <div className="text-[10px] text-muted-foreground shrink-0">{new Date(l.created_at).toLocaleString()}</div>
            </div>
          );
        })}
      </div>
    </Panel>
  );
}
